import React from 'react';
import { Affix, Button, Col, Dropdown, Menu, Row, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import Logo from '../components/Graphics/Logo';


// Generalized PageHeader component
const PageHeader = ({ title, logoUrl, actions, dropdownItems, logoSize='35px' }) => {
  // Generate Dropdown Menu if dropdownItems are provided
  const dropdownMenu = dropdownItems && (
    <Menu>
      {dropdownItems.map((item, index) => (
        <Menu.Item key={index} onClick={() => item.callback()}>
          {item.text}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
      <div className="page-header">
      <Row align="middle" gutter={16} className="px-6 py-2">
        <Col flex="auto" style={{ display: 'flex', alignItems: 'center' }}>
          {logoUrl && <Logo
              height={logoSize}
              width={logoSize}
              src={logoUrl}
              borderRadius={'5px'} />}
          <span className={'page-header-title'} style={{ margin: 0, marginLeft: '16px' }}>{title}</span>
        </Col>
        {actions && actions.map((action, index) => (
          <Col key={index}>
              {action}
          </Col>
        ))}
        {dropdownItems && (
          <Col>
            <Dropdown overlay={dropdownMenu}>
              <Button>
                More Options <DownOutlined />
              </Button>
            </Dropdown>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default PageHeader;